(() => {
  function getEligibility() {
    let stored;
    try {
      stored = JSON.parse(localStorage.getItem('privateSaleEligibility'));
    } catch (e) {
      return null;
    }
    if (!stored || !stored.percent || !Array.isArray(stored.handles) || !stored.handles.length) return null;

    return { percent: stored.percent, handles: stored.handles };
  }

  function parsePriceValue(text) {
    const match = text.replace(/,/g, '').match(/[\d.]+/);
    return match ? parseFloat(match[0]) : null;
  }

  function formatPriceLike(template, value) {
    const match = template.match(/[\d.,]+/);
    return match ? template.replace(match[0], value.toFixed(2)) : template;
  }

  function discountValue(base, percent) {
    // Match Shopify's own discount math: floor the discount amount in cents, don't round the final price.
    const baseCents = Math.round(base * 100);
    const discountCents = Math.floor((baseCents * percent) / 100);
    return (baseCents - discountCents) / 100;
  }

  function adjustNativePrice(priceEl, percent) {
    const saleItem = priceEl.querySelector('.price__sale .price-item--sale');
    const saleStrike = priceEl.querySelector('.price__sale .price-item--regular');
    const regularItem = priceEl.querySelector('.price__regular .price-item--regular');
    const alreadyOnSale = priceEl.classList.contains('price--on-sale');

    if (priceEl.hasAttribute('data-private-sale-adjusted')) {
      const currentItem = priceEl.classList.contains('price--on-sale') ? saleItem : regularItem;
      return currentItem ? currentItem.textContent.trim() : null;
    }

    const baseItem = alreadyOnSale ? saleItem : regularItem;
    if (!baseItem) return null;

    const baseValue = parsePriceValue(baseItem.textContent);
    if (baseValue == null) return null;
    const discountedText = formatPriceLike(baseItem.textContent, discountValue(baseValue, percent));

    if (!alreadyOnSale) {
      if (saleStrike) saleStrike.textContent = regularItem.textContent;
      if (saleItem) saleItem.textContent = discountedText;
      priceEl.classList.add('price--on-sale');
    } else if (saleItem) {
      saleItem.textContent = discountedText;
    }
    priceEl.setAttribute('data-private-sale-adjusted', 'true');

    return discountedText.trim();
  }

  function updateAddToCartButtonPrice(discountedText) {
    if (!discountedText) return;
    if (document.querySelector('[data-hide-price]')?.dataset?.hidePrice === 'true') return;

    const span = document.querySelector('.product-form__submit > span');
    if (!span) return;

    const current = span.textContent.trim();
    if (!current.includes(' - ')) return;

    const label = current.split(' - ')[0];
    const nextText = `${label} - ${discountedText}`;
    if (current !== nextText) span.textContent = nextText;
  }

  function processPDP(eligibility) {
    const match = window.location.pathname.match(/\/products\/([^/?]+)/);
    const handle = match ? match[1] : null;
    if (!handle || !eligibility.handles.includes(handle)) return;

    document.querySelectorAll('[id^="price-"]').forEach((wrapper) => {
      const priceEl = wrapper.querySelector('.price');
      if (!priceEl) return;
      const discountedText = adjustNativePrice(priceEl, eligibility.percent);
      updateAddToCartButtonPrice(discountedText);
    });
  }

  function cardHandle(priceEl) {
    const wrappingLink = priceEl.closest('a[href*="/products/"]');
    if (wrappingLink) return extractHandle(wrappingLink.getAttribute('href'));

    const card = priceEl.closest('.card-wrapper');
    const cardLink = card ? card.querySelector('a[href*="/products/"]') : null;
    return cardLink ? extractHandle(cardLink.getAttribute('href')) : null;
  }

  function extractHandle(href) {
    const match = href && href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function processCards(eligibility) {
    // Covers product cards anywhere else on the site -- recommendations, related products,
    // cart upsells, featured collections, predictive search -- by matching each price block to
    // its nearby product link instead of relying on a specific section passing discount_percent.
    document.querySelectorAll('.price').forEach((priceEl) => {
      if (priceEl.hasAttribute('data-private-sale-adjusted')) return;
      const handle = cardHandle(priceEl);
      if (!handle || !eligibility.handles.includes(handle)) return;
      adjustNativePrice(priceEl, eligibility.percent);
    });
  }

  function adjustCartLine(wrapper, item, percent) {
    if (wrapper.hasAttribute('data-private-sale-adjusted')) return;

    const priceLink = wrapper.querySelector('a[href*="/products/"]:not([aria-hidden])');
    const priceContainer = priceLink ? priceLink.querySelector('div') : null;
    const currentSpan = priceContainer ? priceContainer.querySelector('span') : null;
    if (!currentSpan) return;

    let discountedText;
    if (item.total_discount > 0) {
      // Shopify has already applied the real discount code to this cart -- use its authoritative
      // number instead of re-deriving one, so rounding always matches checkout exactly.
      discountedText = formatPriceLike(currentSpan.textContent, item.final_line_price / 100);
    } else {
      const baseValue = parsePriceValue(currentSpan.textContent);
      if (baseValue == null) return;
      discountedText = formatPriceLike(currentSpan.textContent, discountValue(baseValue, percent));
    }

    let strikeEl = priceContainer.querySelector('s');
    if (!strikeEl) {
      strikeEl = document.createElement('s');
      strikeEl.className = 'sp-text-[#7E7E7E] sp-font-normal sp-font-body';
      strikeEl.textContent = currentSpan.textContent;
      priceContainer.insertBefore(strikeEl, currentSpan);
    }

    currentSpan.textContent = discountedText;
    wrapper.setAttribute('data-private-sale-adjusted', 'true');
  }

  async function processCart(eligibility) {
    let cart;
    try {
      cart = await fetch('/cart.js').then((response) => response.json());
    } catch (e) {
      return;
    }

    cart.items.forEach((item, index) => {
      if (!eligibility.handles.includes(item.handle)) return;
      ['CartDrawer-Item-', 'CartItem-'].forEach((prefix) => {
        const wrapper = document.getElementById(`${prefix}${index + 1}`);
        if (wrapper) adjustCartLine(wrapper, item, eligibility.percent);
      });
    });
  }

  function processAll(eligibility) {
    processPDP(eligibility);
    processCart(eligibility);
    processCards(eligibility);
  }

  function debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }

  function init() {
    const eligibility = getEligibility();
    if (!eligibility) return;

    processAll(eligibility);

    const debouncedProcessAll = debounce(() => processAll(eligibility), 150);
    const observer = new MutationObserver(debouncedProcessAll);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
